import type { Contest } from '@/types/types'

export const useChannel = (contest: Ref<Contest>) => {
  const { t } = useI18n()
  const channelType = [
    {
      id: 1,
      slug: 'sms',
      title: t('pages.contests.contestsCreatePage.message.form.fields.communicationChannel.sms.title'),
      description: t('pages.contests.contestsCreatePage.message.form.fields.communicationChannel.sms.description')
    },
    {
      id: 2,
      slug: 'mail',
      title: t('pages.contests.contestsCreatePage.message.form.fields.communicationChannel.email.title'),
      description: t('pages.contests.contestsCreatePage.message.form.fields.communicationChannel.email.description')
    }
  ]
  const channelTypeModel = ref(
    channelType.filter((channel) => channel.slug === contest.value.messageTemplate.messageChannel?.slug)[0] ||
      channelType[0]
  )

  const changeMessageTemplateText = (slug: string) => {
    const translationBase = 'pages.contests.contestsCreatePage.preview'
    contest.value.messageTemplate.content = t(`${translationBase}.messageTemplate.content.${slug}`, {
      rewardTag: '{{ reward }}'
    })

    contest.value.messageTemplate.subject = t(`${translationBase}.messageTemplate.subject`)
  }

  const updateChannel = () => {
    const selectedChannelId = channelTypeModel.value.id
    const selectedChannelIdSlug = channelTypeModel.value.slug

    contest.value.messageTemplate.messageChannelId = selectedChannelId
    contest.value.sendingNotificationText = t(
      `pages.contests.contestsCreatePage.preview.messageTemplate.sendingNotificationText.${selectedChannelIdSlug}`
    )

    changeMessageTemplateText(selectedChannelIdSlug)
  }

  return {
    channelType,
    channelTypeModel,
    updateChannel
  }
}
